import React, { FC, Fragment } from 'react';
import { Stack, Text } from '@moda/om';
import { useReturnSummary } from '../../../hooks/useReturnSummary';
import { PaymentSummaryRow } from '../PaymentSummaryRow';
import { formatNumber } from '../../../lib/formatNumber';

import './RefundSummary.scss';

interface Props {
  shipmentNumber?: string;
  orderNumber?: string;
}

export const RefundSummary: FC<Props> = ({ shipmentNumber, orderNumber }) => {
  const { returnSummary } = useReturnSummary({ shipmentNumber, orderNumber });

  if (!returnSummary) return null;

  const {
    attributes: {
      currencyUnit,
      refundDetails,
      returnDetails,
      totalRefundAmount,
      taxes,
      taxDetails: { taxType, refundable }
    },
    type
  } = returnSummary;

  const detailList = type === 'request' && refundDetails ? refundDetails : returnDetails;

  return (
    <Stack space={3}>
      <Stack space={4} className="RefundSummary">
        <Text treatment="h5" family="serif">
          Refund Summary
        </Text>

        <Stack space={3}>
          {detailList.map(({ paymentMethod, amount }, index) => (
            <Fragment key={index}>
              {Number(amount) > 0 && (
                <PaymentSummaryRow
                  key={index}
                  label={paymentMethod}
                  value={
                    <>
                      {currencyUnit}
                      {formatNumber(amount)}
                    </>
                  }
                />
              )}
            </Fragment>
          ))}

          <PaymentSummaryRow
            label={taxType}
            value={
              <>
                {currencyUnit}
                {refundable ? formatNumber(taxes) : 'Non-Refundable'}
              </>
            }
          />
        </Stack>

        <div className="RefundSummary__total">
          <PaymentSummaryRow
            label="Total Refund"
            value={
              <>
                {currencyUnit}
                {formatNumber(totalRefundAmount)}
              </>
            }
          />
        </div>
      </Stack>
      <Text color="cement">*Initial shipping charges are non-refundable</Text>
    </Stack>
  );
};
